import { connect } from 'react-redux';

import { hideLoading, showLoading } from 'store/actions/Global';
import PageOverview from './PageOverview';

const mapDispatchToProps = (dispatch) => ({
    hideLoading: () => hideLoading()(dispatch),
    showLoading: () => showLoading()(dispatch),
});

export default connect(null, mapDispatchToProps)(PageOverview);
